import { axiosInstance } from "./axios";
import { IError } from "dto/IError";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import {
  IInitInvoice,
  IInvoiceBuyerData,
  IInvoiceRow,
} from "dto/Invoice/initInvoice";

const queryKeys = {
  initInvoice: "invoiceService.initInvoice",
  // getOfficeMembers: (officeId: string) => ['officeService.getOfficeMembers', officeId]
};

const initInvoice = (): Promise<{ data: IInitInvoice }> => {
  return axiosInstance.get("/ksef/invoice/init");
};

const useInitInvoice = () => {
  return useCustomQuery(queryKeys.initInvoice, () => initInvoice());
};

// const getOfficeMembers = (officeId: string): Promise<{ data: IWorkspaceMember[] }> => {
// return axiosInstance.get(`/office/users?id=${officeId}`)
// }

// const useGetOfficeMembers = (disabled: boolean,officeId: string) => {
//     return useCustomQuery(queryKeys.getOfficeMembers(officeId), () => getOfficeMembers(officeId), {
//         enabled: !disabled
//     })
// }

export interface ICreateInvoice {
  Date: Date;
  Paymentdate: Date;
  Rows: IInvoiceRow[];
  Note?: string;
  Buyer: IInvoiceBuyerData;
}

const createInvoice = (payload: ICreateInvoice): Promise<{ data: IError }> => {
  return axiosInstance.post("/ksef/invoice", payload);
};

const useCreateInvoice = () => {
  return useCustomMutation(createInvoice);
};

export default {
  useInitInvoice,
  useCreateInvoice,
};
